import About from "../Settings/tabs/About"
import ContainerContainer from "../../components/container/ContainerContainer"
import { AuthenticationRole } from "../../Store/Authentication/types"

const Info: React.FC = () => {

    return (
        <ContainerContainer>
            <About role={AuthenticationRole.ROLE_ADJUDICATOR}/>
        </ContainerContainer> 
    )
}

export default Info